import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const documentSignedTemplates = [
  {
    id: '-101001',
    language: Language.EN,
    subject: 'Document(s) signed',
    type: TemplateType.MAIL,
    subType: TemplateSubType.DOCUMENT_SIGNED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: the document(s) related to the lease located at <strong>{{getLeaseMainAddress lease}}</strong> have been signed.</p>
        <p></p>
        <p>Your document(s) has been signed by all stakeholders.</p>
        <p>Please find all signed documents attached.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-101002',
    language: Language.FR,
    subject: 'Document(s) signé(s)',
    type: TemplateType.MAIL,
    subType: TemplateSubType.DOCUMENT_SIGNED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerne: le(s) document(s) relatif(s) au bail sis <strong>{{getLeaseMainAddress lease}}</strong> a/ont été signé(s) par toutes les parties.</p>
        <p></p>
        <p>Le(s) document(s) a/ont été signé par toutes les parties.</p>
        <p>Nous vous prions de trouver l'ensemble des documents signés en pièce jointe.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-101003',
    language: Language.NL,
    subject: 'Ondertekende document(en)',
    type: TemplateType.MAIL,
    subType: TemplateSubType.DOCUMENT_SIGNED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: de document(en) betreffende uw huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong> werd(en) door alle partijen ondertekend.</p>
        <p></p>
        <p>De document(en) werd(en) door alle partijen ondertekend.</p>
        <p>Alle ondertekende documenten vindt u in bijlage.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-101004',
    language: Language.DE,
    subject: 'Dokument(e) unterzeichnet',
    type: TemplateType.MAIL,
    subType: TemplateSubType.DOCUMENT_SIGNED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: die Dokument(e) bezüglich des Mietvertrags in <strong>{{getLeaseMainAddress lease}}</strong> wurden von allen Beteiligten unterzeichnet.</p>
        <p></p>
        <p>Ihre Dokument(e) wurde(n) von allen Beteiligten unterzeichnet.</p>
        <p>Alle unterzeichneten Dokumente finden Sie im Anhang.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
